export default [
  {
    path: '/zjd/policyManage', // 保单管理
    name: 'allpolicy',
    component: () => {
      return import(
        /* webpackChunkName: "allpolicy" */ '@/views/allpolicy/index.vue'
      )
    },
    meta: {
      keepAlive: true
    }
  }
]
